const generatedStrings = new Set();

export function Randomnumber(length = 8) {
  if (length < 2) throw new Error("Length must be at least 2");

  const digits = '0123456789';
  const nonZeroDigits = '123456789';

  let result;

  // Stop infinite loop if full limit reached
  const maxPossible = 9 * Math.pow(10, length - 2) * 9; 
  if (generatedStrings.size >= maxPossible) {
    throw new Error("All unique numbers exhausted");
  }

  do {
    let str = '';

    // first digit (non-zero)
    str += nonZeroDigits[Math.floor(Math.random() * nonZeroDigits.length)];

    // middle digits
    for (let i = 1; i < length - 1; i++) {
      str += digits[Math.floor(Math.random() * digits.length)];
    }

    // last digit (non-zero)
    str += nonZeroDigits[Math.floor(Math.random() * nonZeroDigits.length)];

    result = str;
  } while (generatedStrings.has(result));

  generatedStrings.add(result);
  return result;
}
